import { BasicLifecycle } from "../../componentLibrary/lifecycle.js";
export const PLAYER_DEATH_ANIMATION_TIME_MS = 2000;
export class PlayerLifecycle extends BasicLifecycle {
    constructor() {
        super(...arguments);
        this.aboutToDie = false;
    }
    die() {
        this.aboutToDie = true;
        setTimeout(() => {
            super.die();
        }, PLAYER_DEATH_ANIMATION_TIME_MS);
    }
    isAboutToDie() {
        return this.aboutToDie;
    }
}
